import _isEmpty from 'lodash/isEmpty';

export default function formatOptions(options) {
  if (!options || _isEmpty(options)) return null;

  return Object.keys(options)
    .map(key => `${key}: ${options[key]}`)
    .join(' | ');
}
